export default "__VITE_ASSET__CNuRz0wS__"